// Highlights are very similar to regular broadcasts recordings with a trimmed
// start and stop segment.
//
// The list of all highlights for a given broadcast is at:
//    GET /account/broadcasts/{BID}/highlights
//
// The segment list for a given highlight is at:
//    GET /account/broadcasts/{BID}/highlights/{HID}/segments
//
// ... which can be found via the "view" endpoint:
//    GET /highlights/{HID}/view
//
// The trim points can be managed at:
//    GET/PUT /account/broadcasts/{BID}/highlights/{HID}
//        start_seconds & stop_seconds
//
let module = angular.module('app.resources');

module.factory('Highlight', function Highlight($resource) {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/broadcasts/:broadcastId/highlights/:id`,
    { broadcastId: '@broadcastId', id: '@id' },
    {
      create: {
        method: 'POST',
        url: `${API_ROOT}/account/broadcasts/:broadcastId/highlights`,
      },
      update: {
        method: 'PUT',
      },
      view: {
        method: 'GET',
        url: `${API_ROOT}/highlights/:id/view`,
      },
      prepareDownload: {
        method: 'POST',
        url: `${API_ROOT}/account/highlights/:id/download`,
      },
      getKalturaExportStatus: {
        method: 'GET',
        url: `${API_ROOT}/account/highlights/:id/kaltura_export`,
      },
      startKalturaExport: {
        method: 'POST',
        url: `${API_ROOT}/account/highlights/:id/kaltura_export`,
      },
      getYoutubeExportStatus: {
        method: 'GET',
        url: `${API_ROOT}/account/highlights/:id/youtube_export`,
      },
      startYoutubeExport: {
        method: 'POST',
        url: `${API_ROOT}/account/highlights/:id/youtube_export`,
      },
      getVimeoExportStatus: {
        method: 'GET',
        url: `${API_ROOT}/account/highlights/:id/vimeo_export`,
      },
      startVimeoExport: {
        method: 'POST',
        url: `${API_ROOT}/account/highlights/:id/vimeo_export`,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/highlight.js